import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ProjectItem } from "@/services/entities/ProjectItem";
import { useProjectStore } from "@/stores/project";
import { reactive } from "vue";
import { useVfm, VueFinalModal } from "vue-final-modal";
import ConfirmModal from "./ConfirmModal.vue";
import ProjectForm from "../project/ProjectForm.vue";
import { formatText } from "@/common/util";
import { showToastError } from "@/toastification";
import { isDateInRange } from "@/common/date"


export default /*@__PURE__*/_defineComponent({
  __name: 'EditProjectModal',
  props: {
    value: { Type: {} as ProjectItem, default: {} as ProjectItem }
},
  emits: ["close", "reloadProject"],
  setup(__props, { emit: __emit }) {

const vfm = useVfm();
const confirmModalId = Symbol("confirmModalId");
const assignmentCuttOffModalId = Symbol("assignmentCuttOffModalId");
const projectStore = useProjectStore();
const emit = __emit;

const props = __props;

const mandatoryFields = [
    {
        key: 0, values: [
            "projectName", "projectNumber", "responsiblePerson", "projectManager", "serviceId", "invoiceTypeId"
        ]
    }, {
        key: 1, values: [
            "projectName", "projectNumber", "responsiblePerson", "projectManager",
        ]
    }, {
        key: 2, values: [
            "projectName", "projectNumber", "responsiblePerson", "projectManager",
        ]
    },
];

async function update(event: Event, cutOffAssignments: boolean = false) {

    let canUpdate = true;
    if (props.value.projectStart > props.value.projectEnd) {
        showToastError("Project start date must be before project end date");
        canUpdate = false;
    }

    props.value.projectStart = new Date(Date.UTC(props.value.projectStartPicker.year, props.value.projectStartPicker.month));
    props.value.projectEnd = new Date(Date.UTC(props.value.projectEndPicker.year, props.value.projectEndPicker.month + 1, 0));
    props.value.nonBillableProjectTypeId = props.value.nonBillableProjectType;

    if (!cutOffAssignments) {
        props.value.usersProject.forEach(up => {
            up.participations.forEach(p => {
                if (!isDateInRange(new Date(p.from), props.value.projectStart, props.value.projectEnd) ||
                    !isDateInRange(new Date(p.to), props.value.projectStart, props.value.projectEnd)) {
                    canUpdate = false;                
                    console.log("opening modal")
                    vfm.open(assignmentCuttOffModalId)
                    return;
                }   
            })
        } );
    }    

    if (props.value.projectTypeId >= 0) {
        mandatoryFields.find(a => a.key == props.value.projectTypeId)?.values.forEach(element => {
            const value = props.value[element];
            if (value == null || value.length == 0) {
                showToastError(`Missing value: ${formatText(element)}`);
                canUpdate = false;
            }
        });
        if (canUpdate) {
            props.value.cutOffUserAssignment = cutOffAssignments;
            await projectStore.updateProject(props.value);
            if (cutOffAssignments) {
                emit("reloadProject", props.value.id);
            }
            emit("close");            
        }
    } else {
        showToastError("Select project type")
    }
}

function beforeClose() {
    vfm.open(confirmModalId);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(VueFinalModal), {
    class: "modal",
    "content-class": "modal-content",
    "overlay-transition": "vfm-fade",
    clickToClose: false,
    onClickOutside: beforeClose
  }, {
    default: _withCtx(() => [
      _createVNode(ProjectForm, {
        value: props.value,
        edit: true
      }, {
        header: _withCtx(() => [...(_cache[4] || (_cache[4] = [
          _createElementVNode("span", { class: "title" }, "Edit project", -1)
        ]))]),
        buttons: _withCtx(() => [
          _createElementVNode("div", { class: "buttons" }, [
            _createElementVNode("button", { onClick: beforeClose }, "Cancel"),
            _createElementVNode("button", {
              class: "accent",
              onClick: update
            }, "Save changes")
          ])
        ]),
        _: 1
      }, 8, ["value"]),
      _createVNode(ConfirmModal, {
        "modal-id": _unref(confirmModalId),
        text: "You have unsaved changes, do you really want to leave this form?",
        "confirm-text": "Close form",
        onConfirm: _cache[0] || (_cache[0] = () => {
                _unref(vfm).close(_unref(confirmModalId));
                emit('close');
            }
                ),
        onClose: _cache[1] || (_cache[1] = ($event: any) => (_unref(vfm).close(_unref(confirmModalId))))
      }, null, 8, ["modal-id"]),
      _createVNode(ConfirmModal, {
        "modal-id": _unref(assignmentCuttOffModalId),
        text: "User Assignment(s) are out of project Start/End bounds. Should I try to cut off assignment period automaticaly - with respect to reported hours?",
        "confirm-text": "Try adjust Assignments",
        onConfirm: _cache[2] || (_cache[2] = () => {
                _unref(vfm).close(_unref(assignmentCuttOffModalId));
                update(null, true);
                }),
        onClose: _cache[3] || (_cache[3] = () => {
                _unref(vfm).close(_unref(assignmentCuttOffModalId));
                emit('close');
            })
      }, null, 8, ["modal-id"])
    ]),
    _: 1
  }))
}
}

})